import React, { useState } from 'react';
import './index.css';
import { Sidebar } from './components/layout/Sidebar';
import { Overview }  from './pages/Overview';
import { Sessions }  from './pages/Sessions';
import { HotLeads }  from './pages/HotLeads';
import { LiveFeed }  from './pages/LiveFeed';
import { Analytics } from './pages/Analytics';
import { useSocket } from './hooks/useSocket';
import { useHotLeads } from './hooks/useData';

const PAGE_TITLES: Record<string, { title: string; sub: string }> = {
  overview:  { title: 'Dashboard',    sub: 'Visitor intelligence overview' },
  live:      { title: 'Live Feed',    sub: 'Real-time visitor events' },
  sessions:  { title: 'Sessions',     sub: 'All captured visitor sessions' },
  leads:     { title: 'Hot Leads',    sub: 'Visitors who gave consent' },
  analytics: { title: 'Analytics',   sub: 'Traffic and conversion insights' },
  settings:  { title: 'Settings',    sub: 'Account and configuration' },
};

export default function App() {
  const [page, setPage] = useState('overview');
  const { connected, events } = useSocket();
  const { leads } = useHotLeads();
  const meta = PAGE_TITLES[page] ?? PAGE_TITLES.overview;

  return (
    <div className="app">
      <Sidebar
        page={page}
        setPage={setPage}
        connected={connected}
        hotCount={leads.filter((l: any) => !l.outreachSent).length}
      />

      <div className="main">
        <div className="topbar">
          <div>
            <div className="topbar-title">{meta.title}</div>
            <div className="topbar-subtitle">{meta.sub}</div>
          </div>
          <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
            <div style={{ width: 7, height: 7, borderRadius: '50%', background: connected ? 'var(--green)' : 'var(--red)' }} />
            <span style={{ fontSize: 12, color: 'var(--text3)', fontFamily: 'var(--mono)' }}>
              {connected ? 'api.monashi.ai' : 'disconnected'}
            </span>
          </div>
        </div>

        {page === 'overview'  && <Overview  events={events} setPage={setPage} />}
        {page === 'live'      && <LiveFeed  events={events} connected={connected} />}
        {page === 'sessions'  && <Sessions />}
        {page === 'leads'     && <HotLeads />}
        {page === 'analytics' && <Analytics />}
        {page === 'settings'  && (
          <div className="page">
            <div className="empty">
              <div className="empty-title">Settings coming soon</div>
              <div style={{ fontSize: 12, color: 'var(--text3)' }}>API keys, workspace config, billing</div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}
